module.exports = __webpack_public_path__ + "fonts/418e43d.eot";